import { Button } from "lumir-back-office-ui";
import useDisplay from "../../../hooks/useDisplay";
import { useNavigate, useSearchParams } from "react-router-dom";

export default function ApplyFailed() {
  const { isMobile } = useDisplay();
  const navigate = useNavigate();

  //searchParams 조회
  const [searchParams] = useSearchParams();
  const message = searchParams.get("message");
  const applyTitle = searchParams.get("applyTitle");

  const isDuplicate = message?.includes("중복 지원은 불가능합니다") || false;

  return (
    <div id="tailwind-root">
      <div
        className="flex flex-col items-center justify-center h-screen text-center mx-[24px]"
      >
        <img
          src="/assets/icons/confirmation.svg"
          alt="Confirmation Icon"
          className="w-[68px] h-[68px] text-white rounded-full p-2"
        />

        <p
          className={`mt-[32px] mb-[6px] ${
            isMobile
              ? "typography-semantic-heading-1-bold"
              : "typography-semantic-title-1-bold"
          }`}
        >
          {isDuplicate
            ? "이미 지원한 공고입니다."
            : "제출 중 오류가 발생했습니다."}
        </p>
        <p
          className={`text-semantic-secondary-foreground-inverse-default mb-[16px] ${
            isMobile
              ? "typography-semantic-body-2-reading---regular"
              : "typography-semantic-body-2-reading---regular"
          }`}
        >
          공고명: {applyTitle}
        </p>
        <p
          className={`text-semantic-secondary-foreground-strong-default ${
            isMobile
              ? "typography-semantic-body-1-reading---regular"
              : "typography-semantic-heading-3-regular"
          }`}
        >
          {isDuplicate && "이미 지원하신 공고는 다시 지원하실 수 없습니다."}
        </p>
        <Button
          size={isMobile ? "lg" : "xlg"}
          variant="filled"
          state="primary"
          className="w-[100px] h-[36px] mt-[40px] rounded-md"
          onClick={() => navigate("/")}
        >
          홈으로
        </Button>
      </div>
    </div>
  );
}
